export const PhotoQcFieldName = 'photoQcFieldComponent';
